import { render, staticRenderFns } from "./DownloadPage.vue?vue&type=template&id=3318f4ff&scoped=true&"
import script from "./DownloadPage.vue?vue&type=script&lang=js&"
export * from "./DownloadPage.vue?vue&type=script&lang=js&"
import style0 from "./DownloadPage.vue?vue&type=style&index=0&id=3318f4ff&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3318f4ff",
  null
  
)

export default component.exports